import { useExternalParams } from 'shared/hooks/use-external-params';
import { useMemo } from 'react';
import { PaymentUsersFilters } from './use-payment-users.types';
import { stringifyFilters } from '../../../../../../shared/utils/stringify-filters';

const initialValues = {
  iban: {
    initialValue: undefined,
    type: 'string',
  },
  worker: {
    initialValue: undefined,
    type: 'string',
  },
  state: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export const usePaymentUsersPage = () => {
  const [params, setParams] = useExternalParams(initialValues);

  const filters: PaymentUsersFilters = {
    iban: params.iban || undefined,
    worker: params.worker || undefined,
    state: params.state || undefined,
  };

  const selectedFilterCount = Object.values(filters).filter(Boolean).length;

  const stringifiedFilters = useMemo(() => stringifyFilters(filters), [filters]);

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
    stringifiedFilters,
  };
};
